import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const reducer = {
  [types.GET_POSTS_FULFILLED]: (state, { posts }) => posts,
};

export default function postReducer(state = intialState.posts, action) {
  return action.type in reducer
    ? reducer[action.type](state, action.payload)
    : state;
}
